import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { Breadcrumb, Button, Skeleton, message } from 'antd';
import { userPermissions } from 'shared/constant';
import { permissionService } from 'shared/services';

import CompanyModules from '../CompanyRegister/CompanyModules';
import EmployeeRolesView from '../CompanyRegister/EmployeeRolesView';

import organizationRoute from '../../route';

import text from './EmployeeDetail.page.translation';

import './EmployeeDetail.style.less';

export class EmployeeDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      companyId: this.props.match.params.id || '',
    };
  }

  componentDidMount() {
    if (this.state.companyId) {
      this.props.getSingleEmployee(this.state.companyId);
    }
  }

  _deactivated = () => {
    const { employeeDetail } = this.props;
    this.props.deactivatedUser(
      employeeDetail.payload.user_details.user_id,
      this._callbackActivatedDeactivated,
    );
  };

  _callbackActivatedDeactivated = status => {
    const {
      intl: { formatMessage },
    } = this.props;
    if (status === 'deactivated') {
      message.success(formatMessage(text.deactivatedSuccess));
    } else {
      message.success(formatMessage(text.activatedSuccess));
    }

    if (this.state.companyId) {
      this.props.getSingleEmployee(this.state.companyId);
    }
  };

  _activated = () => {
    const { employeeDetail } = this.props;
    this.props.activatedUser(
      employeeDetail.payload.user_details.user_id,
      this._callbackActivatedDeactivated,
    );
  };

  renderRowData(data, key) {
    if (data[key].url) {
      return (
        <div key={key} className="detail-row-url-container">
          <div>{data[key].label}</div>
          <div>
            <img className="detail-photo" src={data[key].url} alt="" />
          </div>
        </div>
      );
    }

    return (
      <div key={key} className="detail-row-container">
        <div className="detail-row-label">{data[key].label}</div>
        <div className="detail-row-value">{data[key].value}</div>
      </div>
    );
  }

  _getContentLeftValue = employeeDetail => {
    const result = {
      employeeName: '-',
      userEmail: '-',
      userPhone: '-',
    };

    if (_.get(employeeDetail, 'payload')) {
      const employeeData = employeeDetail.payload;

      const firstname = _.get(employeeData, 'firstname', '');
      const lastname = _.get(employeeData, 'lastname', '');
      result.employeeName = `${firstname} ${lastname}`;

      if (employeeData.user_details) {
        result.userEmail = employeeData.user_details.email;
        result.userPhone = employeeData.user_details.phone_mobile;
      }
    }

    return result;
  };

  _renderContentLeft = () => {
    const {
      employeeDetail,
      loading,
      intl: { formatMessage },
    } = this.props;
    let listLeftSection = '';

    const value = this._getContentLeftValue(employeeDetail);

    const listLeftData = [
      {
        label: formatMessage(text.labelName),
        value: value.employeeName,
      },
      {
        label: formatMessage(text.labelEmail),
        value: value.userEmail,
      },
      {
        label: formatMessage(text.labelPhone),
        value: value.userPhone,
      },
    ];

    listLeftSection = Object.keys(listLeftData).map(
      this.renderRowData.bind(this, listLeftData),
    );

    return (
      <Skeleton
        loading={loading}
        active
        paragraph={{
          rows: 4,
          width: ['100%', '100%', '100%', '100%'],
        }}
        title={false}
      >
        {listLeftSection}
      </Skeleton>
    );
  };

  _combineRolesToString = roles => {
    let result = '-';
    if (roles.length) {
      roles.forEach((role, index) => {
        if (index > 0) {
          result += `, ${role.name}`;
        } else {
          result = role.name;
        }
      });
    }

    return result;
  };

  _getContentRightValue = employeeDetail => {
    const result = {
      employeeKtp: '-',
      roles: '-',
      employeePhoto: 'https://via.placeholder.com/100x100',
    };

    if (_.get(employeeDetail, 'payload')) {
      const employeeData = employeeDetail.payload;

      result.employeeKtp = employeeData.ktp_num;

      if (employeeData.user_details) {
        result.roles = this._combineRolesToString(
          employeeData.user_details.user_role,
        );

        result.employeePhoto = employeeData.user_details.profile_picture_url;
      }
    }

    return result;
  };

  _renderContentRight = () => {
    const {
      employeeDetail,
      loading,
      intl: { formatMessage },
    } = this.props;
    let listRightSection = '';

    const value = this._getContentRightValue(employeeDetail);

    const listRightData = [
      {
        label: formatMessage(text.labelKtp),
        value: value.employeeKtp,
      },
      {
        label: formatMessage(text.labelPhoto),
        url: value.employeePhoto,
      },
    ];

    listRightSection = Object.keys(listRightData).map(
      this.renderRowData.bind(this, listRightData),
    );

    return (
      <Skeleton
        loading={loading}
        active
        paragraph={{
          rows: 4,
          width: ['100%', '100%', '100%', '100%'],
        }}
        title={false}
      >
        {listRightSection}
      </Skeleton>
    );
  };

  _goToEditPage = employeeId => {
    this.props.history.push(
      organizationRoute.EMPLOYEE_EDIT.replace(':id', employeeId),
    );
  };

  _renderEditbtn = () => {
    const {
      employeeDetail,
      intl: { formatMessage },
    } = this.props;

    const employeeId = _.get(employeeDetail, 'payload.employee_id');

    return (
      <Button
        type="primary"
        block
        className="btn edit-btn"
        onClick={() => this._goToEditPage(employeeId)}
      >
        {formatMessage(text.btnEdit)}
      </Button>
    );
  };

  _getDeactivatedBtnStyle = blocked => {
    const {
      intl: { formatMessage },
    } = this.props;

    const result = {};

    if (blocked) {
      result.btnText = formatMessage(text.btnActivated);
      result.btnType = 'primary';
      result.onClick = this._activated;
    } else {
      result.btnText = formatMessage(text.btnDeactivated);
      result.btnType = 'danger';
      result.onClick = this._deactivated;
    }

    return result;
  };

  _renderDeactivatedbtn = () => {
    const style = this._getDeactivatedBtnStyle(
      this.props.employeeDetail.payload.user_details.blocked,
    );

    return (
      <Button
        type={style.btnType}
        block
        className="btn deactivated-btn"
        onClick={style.onClick}
      >
        {style.btnText}
      </Button>
    );
  };

  render() {
    const {
      intl: { formatMessage },
      loading,
      me,
      employeeDetail,
    } = this.props;

    const { checkPermission } = permissionService;
    const permission =
      !loading && checkPermission(userPermissions.UPDATE_EMPLOYEE, true);
    const isPIC = _.get(me, 'user_details.user_metadata.pic', false);
    const currentCompany =
      _.get(me, 'organization_details.organization_id') ===
      _.get(employeeDetail, 'payload.organization_details.organization_id');

    const isSuper = _.get(me, 'user_details.user_metadata.super_admin', false);

    const canDeactive = (isPIC && currentCompany) || isSuper;

    const isCurrentEmployee =
      _.get(me, 'employee_id') === _.get(employeeDetail, 'payload.employee_id');

    const canEdit = canDeactive || isCurrentEmployee;

    const employeeRoles = _.get(
      employeeDetail,
      'payload.user_details.user_role',
      [],
    );
    const displayEmployeeRoles = employeeRoles.map(x => ({
      ...x,
      disabled: true,
      checked: true,
      hidden: false,
    }));

    return (
      <div className="main-content">
        <div className="breadcrumb-wrapper">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={organizationRoute.EMPLOYEE_LIST}>
                {formatMessage(text.breadcrumbList)}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {formatMessage(text.breadcrumbDetail)}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="white-box-wrapper employee-detail-white-box">
          <div className="employee-details-container">
            <div className="title-container">{formatMessage(text.title)}</div>
            <div className="content-container">
              <div className="content-left-container">
                {this._renderContentLeft()}
              </div>
              <div className="content-right-container">
                {this._renderContentRight()}
              </div>
            </div>
          </div>

          <div className="employee-roles-container">
            <div className="roles-title">Available Employee Roles</div>
            <CompanyModules
              availableModules={displayEmployeeRoles}
              colSpan={6}
              placeholder="Loading data..."
            />

            <div className="employee-roles-view">
              <EmployeeRolesView
                employeeRoles={displayEmployeeRoles}
                placeholder="Loading data..."
              />
            </div>
          </div>

          {permission && canEdit && this._renderEditbtn()}
          {permission && canDeactive && this._renderDeactivatedbtn()}
        </div>
      </div>
    );
  }
}

EmployeeDetail.propTypes = {
  history: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  getSingleEmployee: PropTypes.func.isRequired,
  activatedUser: PropTypes.func.isRequired,
  deactivatedUser: PropTypes.func.isRequired,
  employeeDetail: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  match: PropTypes.object,
  me: PropTypes.object,
};

export default EmployeeDetail;
